import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {ReactComponent as Document} from '../../../assets/images/document.svg'
import {ReactComponent as Upload} from '../../../assets/images/Upload-Red.svg'

import Card from "@mui/material/Card";
import CardHeader from "@mui/material/CardHeader";
import CardContent from "@mui/material/CardContent";

import "./UtiRequests.scss";
import { Button, SvgIcon } from "@mui/material";
import { open } from "../../../redux/actions/modalActions";

function UtiRequests(props) {
  const { data } = useSelector((state) => state.data);
  const dispatch = useDispatch();
  console.log(props);  
  const openDialog = (name) => {
    dispatch(open(name));
  };
  const showBtn = (name) => {
    switch (name) {
      case "temp_lic":
        return !data?.tempLicEnabled;
        // return true;
      case "shiabud_form":
        return !data?.paymentSection?.shiabudRequestEnabled;
      case "DocUpload":
        return !data?.uploadEnabled;
        // case 'torLink':
        //   return false;
        default :return true;
    }
  };

  const buttons = [
    {
      title: "הנפקת רישיון זמני",
      icon: Document,
      footerText: "שליחת בקשה",
      footerStyle: "",
      dialogName: "temp_lic",
      show: (data?.tempLicEnabled ? true : (data?.tempLicEnabled === undefined || data?.tempLicEnabled === null ? false : true))
    },
    {
      title: "טופס שיעבוד",
      icon:Document ,
      footerText: "שליחת בקשה",
      footerStyle: "",
      dialogName: "shiabud_form",
      show: (data?.paymentSection?.shiabudRequestEnabled ? true : (data?.paymentSection?.shiabudRequestEnabled === undefined || data?.paymentSection?.shiabudRequestEnabled === null ? false : true))
    },
    {
      title: "העלאת מסמכים",
      icon: Upload,
      footerText: "העלאת קובץ",
      footerStyle: "footer_link",
      dialogName: "DocUpload",
      show: (data?.uploadEnabled ? true : (data?.uploadEnabled === undefined || data?.uploadEnabled === null ? false : true))
    }
  ]
  const [titles, setTitles] = useState({
    inStockDate: "במלאי",
    shiabudRequestData: "בקשה לטופס שיעבוד",
    paymentDate: "תשלום",
    welcomeDate: "שיחת וולקום",
    hovaInsur: "ביטוח חובה",
    pdiDate: "PDI",
    buildingDate: "בונה ארגז",
    extraDate: "התקנות נוספות",
    Lic: "תהליך רישוי",
    qualtiCtrlDate: "בקרת איכות",
    deliveryAppoint: "תיאום מסירה",
    deliveryDate: "מסירה",
  });

  return (
    <Card className="uti-docs-box req_box">
      <CardHeader title={"שליחת בקשות ל UTI"}></CardHeader>
      <CardContent className="uti-card">
        {buttons.map(
          (btn) => {
            if (btn.show) {
              return <Button
              disabled={showBtn(btn.dialogName)}
                className="req_button"
                onClick={() => {
                  openDialog(btn.dialogName);
                }}
              >
                <SvgIcon
                  component={btn.icon}
                  className="doc_icon"
                  inheritViewBox
                />
                <span className="label_without_subtitle">{btn.title}</span>
                <div className={`btn_footer ${btn.footerStyle}`}>
                  {btn.footerText}
                </div>
              </Button>
            }
          }
            
        )}
      </CardContent>
    </Card>
  );
}

export default UtiRequests;
